import { IItem } from "@/redux/profile/history/types";

const WEEKDAYS = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
const MONTHS = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
];

export const formatDate = (dateStr: string): string => {
  try {
    const [year, month, day] = dateStr.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    
    const weekday = WEEKDAYS[date.getDay()];
    const monthName = MONTHS[date.getMonth()];
    
    return `${weekday}, ${day} ${monthName} ${year}`;
  } catch (error) {
    return dateStr;
  }
};

export const groupByDate = (items: IItem[]): { [key: string]: IItem[] } => {
  return items.reduce((acc, item) => {
    const dateKey = item.dateForSort?.split('T')[0] || item.dateForSort?.split(' ')[0] || '';
    if (!dateKey) return acc;
    
    const formattedKey = formatDate(dateKey);
    if (!acc[formattedKey]) {
      acc[formattedKey] = [];
    }
    acc[formattedKey].push(item);
    return acc;
  }, {} as { [key: string]: IItem[] });
};

export const getFinishTime = (item: IItem): Date | null => {
  try {
    const dateStr = item.dateForSort || item.timeStart;
    if (!dateStr) return null;
    
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return null;
    
    const finishTime = new Date(date.getTime() + (item.duration || 0) * 60 * 1000);
    return finishTime;
  } catch (error) {
    return null;
  }
};
